if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      /** Custom Musaib's Code **/
      this.isSubmitting = false;
      this.setupStickyAtc();

      this.hideErrors = this.dataset.hideErrors === 'true';
     this.buyItNow = this.querySelector('shopify-buy-it-now-button');
      if(this.buyItNow){
        this.buyItNow.querySelector('button').classList.add('button','button--secondary');
         this.buyItNow.querySelector('button').innerText = '⚡ Buy Now';
      }
      this.permalink = this.querySelector('[data-cartpermalink]');
      if(this.permalink){
        this.permalink.addEventListener('click',(e)=>{
          e.preventDefault();
          e.stopImmediatePropagation();
          this.permalink.classList.add('loading');
          this.permalink.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          let variant_id =  this.form.querySelector('[name=id]').value;
          
          const formData = new FormData(this.form);
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(data =>{
         console.log(data); 
          let quick_checkout = document.querySelector('#CartDrawer [name="checkout"]');
               if (quick_checkout){
                 quick_checkout.removeAttribute('disabled');
                   quick_checkout.click();
                 }
        })
        .catch(error =>{
            console.log(error)
        })
        .finally(()=>{
          this.permalink.classList.remove('loading');
          this.permalink.querySelector('.loading-overlay__spinner').classList.add('hidden');
        })
          

          /**
          let propertiesData = '';
            formData.forEach((value,key)=>{
                if(key.includes('properties')){
                    let v = value.replaceAll(' ','+');
                    let k = key.split('[')[1].split(']')[0].replaceAll(' ','+');
                    let prop = `&items[][properties][${k}]=${v}`;
                    propertiesData += prop; 
                }
            });
          // let perlink_url_to_shopify_checkout =`/cart/add?items[][id]=${variant_id}&items[][quantity]=1${propertiesData}&return_to=/checkout`;
          // window.location.href = perlink_url;
          //  let perlink_url_to_quick_checkout =`/cart/add?items[][id]=${variant_id}&items[][quantity]=1${propertiesData}`;
               
          fetch(`${perlink_url_to_quick_checkout}`).then(r => {
              if(r.status == 200 || r.status == 302){
               let quick_checkout = document.querySelector('[name="checkout"]');
                     if (quick_checkout) {
                         quick_checkout.click();
                       }else{
                       window.location.href = "/checkout";
                     }
               }else{
                window.location.href = perlink_url_to_quick_checkout+"&return_to=/checkout";
               }
          }).catch(err=>{
               window.location.href = perlink_url_to_quick_checkout+"&return_to=/checkout";
          })
          **/  

        
        });
      }
      /** Custom Code end **/
    }
    

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.isSubmitting) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.isSubmitting = true;
      this.setLoadingState(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.isSubmitting = false;
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.setLoadingState(false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    /**
     * The sticky bar belongs to a single form: the one its button submits through
     * the `form` attribute. Any other product-form on the page (cards, quick add)
     * must not drive its visibility.
     */
    setupStickyAtc() {
      const container = document.querySelector('.atc-sticky-container');
      const formId = this.getFormId();
      if (!container || !formId) return;
      if (!container.querySelector(`[form="${CSS.escape(formId)}"]`)) return;

      this.stickyContainer = container;

      if (this.querySelector('button[disabled][name="add"]')) {
        this.stickyContainer.querySelector('button')?.setAttribute('disabled', 'disabled');
      }

      const anchor = this.querySelector('.product-form__buttons') || this.submitButton;
      if (!anchor) return;

      const update = (buttonsVisible) => this.stickyContainer.classList.toggle('hidden', buttonsVisible);

      if ('IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver(
          (entries) => entries.forEach((entry) => update(entry.isIntersecting)),
          { threshold: 0 }
        );
        this.stickyObserver.observe(anchor);
        return;
      }

      const onViewportChange = () => {
        const rect = anchor.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        update(rect.bottom > 0 && rect.top < viewportHeight);
      };
      window.addEventListener('scroll', onViewportChange, { passive: true });
      window.addEventListener('resize', onViewportChange);
      onViewportChange();
    }

    /**
     * `form.id` cannot be used: the form owns an `<input name="id">`, and named
     * form controls shadow the element's own properties.
     */
    getFormId() {
      return this.form.getAttribute('id');
    }

    /** Every button that submits this form, including the sticky one outside of it. */
    getSubmitButtons() {
      const buttons = this.submitButton ? [this.submitButton] : [];
      const formId = this.getFormId();
      if (!formId) return buttons;
      document
        .querySelectorAll(`[form="${CSS.escape(formId)}"][name="add"]`)
        .forEach((button) => {
          if (!buttons.includes(button)) buttons.push(button);
        });
      return buttons;
    }

    setLoadingState(loading) {
      this.getSubmitButtons().forEach((button) => {
        const spinner = button.querySelector('.loading-overlay__spinner');
        button.classList.toggle('loading', loading);
        spinner?.classList.toggle('hidden', !loading);

        if (loading) {
          button.setAttribute('aria-disabled', 'true');
        } else if (!this.error && !button.hasAttribute('disabled')) {
          button.removeAttribute('aria-disabled');
        }
      });
    }
  });
}
